module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-120x120-6c550393f7efb4ed6308f92423da86d0.png";